import { appConfig } from "../config";

/**
 * Injects the Google Analytics (gtag.js) snippet at runtime.
 *
 * This used to be baked directly into index.html via Vite's build-time
 * `%VITE_GOOGLE_ANALYTICS_KEY%` HTML placeholder. That works fine for builds
 * that have a real `.env` available (e.g. the legacy stripperfans production
 * deploy, which builds on the target host where `.env` already exists), but
 * breaks for the peoplesfans ECR pipeline: the CI `publish` stage builds the
 * Docker image from a plain git checkout with no `.env` (it's gitignored),
 * so the placeholder gets baked in as an empty string and is never
 * revisited afterwards, even though the correct key is available at
 * container startup via window.APP_CONFIG (see public/runtime-config.js.template).
 *
 * Reading `appConfig.googleAnalyticsKey` here resolves the key the same way
 * the rest of the app does: window.APP_CONFIG (runtime) first, falling back
 * to import.meta.env (build-time) - so it works regardless of which
 * pipeline built the image.
 */
export function initGoogleAnalytics() {
  const gaKey = appConfig.googleAnalyticsKey;
  if (!gaKey || typeof document === "undefined") return;

  const target = document.getElementById("google_analytics") || document.head;

  const gtagScript = document.createElement("script");
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaKey}`;
  target.appendChild(gtagScript);

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
  window.gtag("js", new Date());
  window.gtag("config", gaKey);
}

export default initGoogleAnalytics;
